import type { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum, TierUnit, CalculationMethodType, StaffelUnit } from "__generated__/graphql";

export const WaterLevelSchema: RegistryItem = {
	[AgreementTypeEnum.WaterLevel]: {
		defaultValues: {
			calculationMethod: {
				type: null,
				tierUnit: TierUnit.WaterLevel,
				staffelUnit: StaffelUnit.WaterLevel,
			},
		},
		agreementFields: {
			"agreement.manualActionRequired": { rules: { hiddenIf: ({ calculationMethodType }) => calculationMethodType === CalculationMethodType.Staffel } },
			"agreement.conditions": { rules: { hiddenIf: ({ calculationMethodType }) => calculationMethodType === CalculationMethodType.Staffel } },
			"agreement.costType": { rules: { hiddenIf: ({ calculationMethodType }) => calculationMethodType !== CalculationMethodType.Staffel } },
			"agreement.description": { rules: { hiddenIf: ({ calculationMethodType }) => calculationMethodType !== CalculationMethodType.Staffel } },
		},
		calculationMethodFields: {
			"calculationMethod.tierUnit": { rules: { hidden: true } },
		},
	},
};
